const defaultSettings = {
  navText: [
    "<i class='fa fa-angle-left'></i>",
    "<i class='fa fa-angle-right'></i>"
  ],
}

export class Carousel {

  headerhome() {
    const $headerhome = $('.owl-header-home')
    let headerhome = {
      // animateOut: 'fadeOut',
      autoplayTimeout: 8000,
      autoplayHoverPause: true,
      autoplay: true,
      dots: true,
      items: 1,
      loop: false,
      nav: false,
      mouseDrag:false,
    }

    headerhome = $.extend(headerhome, defaultSettings)

    $headerhome
    .owlCarousel(headerhome)
  }

  defaultGallery() {
    const $defaultGallery = $('.owl-gallery')
    let defaultGallery = {
      // animateOut: 'fadeOut',
      autoplayTimeout: 8000,
      autoplayHoverPause: true,
      autoplay: true,
      dots: false,
      items: 1,
      loop: true,
      nav: true,
      mouseDrag:false,
      responsive: {
        600: {
          items: 2,
        },
        0: {
          items: 1,
        }
      }
    }

    defaultGallery = $.extend(defaultGallery, defaultSettings)

    $defaultGallery
    .owlCarousel(defaultGallery)
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/utilities/src/carousel.js